export default __webpack_public_path__ + "static/media/EBaseline.9f7f10e5.svg";